<template>
  <div id="no-mode-absolute-demo" class="demo">

    <!--<button @click="on = !on">AAAA</button>-->
    <!--<button @click="next">NEXT</button>-->

    <div class="no-mode-absolute-demo-wrapper">

      <transition name="no-mode-absolute-fade">
        <div v-bind:key="currentIndex">
          <div class="image_box">
            <img v-bind:src="contents[currentIndex%contents.length].image">
          </div>
          <div class="container slide_content">
            <strong>{{ $t(contents[currentIndex%contents.length].title) }}</strong>
            <p>{{ $t(contents[currentIndex%contents.length].contents) }}</p>
            <!--<a v-on:click="goPage('centerpurpose')">{{ $t("home_slide_more") }}</a>-->
          </div>
          <!--<button @click="on = true">-->
          <!--off-->
          <!--</button>-->
        </div>
      </transition>
    </div>
  </div>
</template>

<style scoped>
  .no-mode-absolute-demo-wrapper {
    position: relative;
    height: 370px;
  }

  .no-mode-absolute-demo-wrapper .image_box {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    height: 370px;
    overflow: hidden;
  }
  .no-mode-absolute-demo-wrapper .image_box img {
    position: absolute;
    left: 50%;
    top: 50%;
    height: 100%;
    width: auto;
    -webkit-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    object-fit: cover;
  }

  .no-mode-absolute-demo-wrapper .slide_content {
    position: absolute;
    top: 0px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .no-mode-absolute-demo-wrapper .slide_content strong {
    color: #fff;
    font-size: 3.30em;
    letter-spacing: normal;
    font-weight: 700;
  }

  .no-mode-absolute-demo-wrapper .slide_content p {
    margin-top: 10px;
    font-size: 1.18em;
    color: #f9f9f9;
    font-weight: 300;
    letter-spacing: normal;
    line-height: 1.8;
    width: 50%;
  }

  .no-mode-absolute-demo-wrapper .slide_content a {
    margin-top: 35px;
    background: url(/static/img/v_arr.png) 90px 2px no-repeat;
    display: inline-block;
    padding: 8px 54px 8px 22px;
    border: 1px solid #fff;
    border-radius: 20px;
    color: #fff;
    font-weight: 400;
    font-size: 13px;
    word-wrap: break-word;
    word-break: keep-all;
  }

  @media (max-width:1000px){
    .no-mode-absolute-demo-wrapper .slide_content {
      width: 100% !important;
      text-align: center;
    }
    .no-mode-absolute-demo-wrapper .slide_content p {
      width: 100%;
    }
  }

  @media (max-width:568px){
    .no-mode-absolute-demo-wrapper .slide_content strong {
      font-size: 2.4em;
    }
    .no-mode-absolute-demo-wrapper .slide_content p {
      font-size: 14px;
      line-height: 1.4;
    }
  }

  .no-mode-absolute-fade-enter-active, .no-mode-absolute-fade-leave-active {
    transition: opacity 1.5s;
  }

  .no-mode-absolute-fade-enter, .no-mode-absolute-fade-leave-active {
    opacity: 0;
  }

  .fade-transition {
    transition: all 2.8s ease;
    overflow: hidden;
    visibility: visible;
    opacity: 1;
    position: absolute;
  }

  .fade-enter, .fade-leave {
    opacity: 0;
    visibility: hidden;
  }

  .boxx {
    border: solid 1px black;
    width: 500
  }
</style>
<script>
  export default {
    name: 'MainSlider',
    data: function () {
      return {
        on: true,
        currentIndex: 0,
        timer: null,
        show: true,
        images: ['../static/img/main_visual_01.jpg', '../static/img/main_visual_02.jpg'],
        contents: [
          {
            title: "",
            contents: "",
            image: "../static/img/main_visual_01.jpg"
          }          ,
          {
            title: "",
            contents: "",
            image: "../static/img/main_visual_02.jpg"
          }          ,
          {
            title: "",
            contents: "",
            image: "../static/img/main_visual_03.jpg"
          }
        ]
      }
    },
    mounted: function () {
      console.log('## on ready')
      this.startRotation();
    },
    methods: {
      test: function() {
        console.log('## currentIndex ' + this.currentIndex + ' ' + this.contents[this.currentIndex%this.contents.length].image)
      },
      startRotation: function () {
        console.log('## on startRotation')
        this.timer = setInterval(this.next, 5000);
      },
      stopRotation: function () {
        clearTimeout(this.timer);
        this.timer = null;
        console.log('## on timer abcd')
      },
      next: function () {
        this.currentIndex += 1
        //console.log('### on timer next ---- ' + this.currentIndex)
      },
      prev: function () {
        this.currentIndex -= 1
      },
      hide: function () {
        this.show = false
      },
      show2: function () {
        this.show = true
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/MainSlider.vue